module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "prepend-icon": "mdi-eye",
      "label": "View by...",
      "item-text": "text",
      "item-value": "value",
      "items": _vm.items
    },
    on: {
      "change": _vm.updateView
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
},staticRenderFns: []}